var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartFilledNopadding = function SvgHeartFilledNopadding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.442 22.886C22.9 17.06 25.298 10.236 23.416 5.573c-.92-2.28-2.848-3.908-5.114-4.41-2.061-.457-4.333.031-6.3 1.68-1.967-1.649-4.24-2.137-6.3-1.68-2.267.502-4.195 2.13-5.115 4.41-1.882 4.664.516 11.486 10.974 17.313a.907.907 0 0 0 .881 0Z"
  })));
};
export default SvgHeartFilledNopadding;